import ApplicationAdapter from './application';
import type ObservableDocumentModel from 'tio-common/models/observable-document';

const MODEL_TYPE = 'observable-document';

class ObservableDocumentAdapter extends ApplicationAdapter {
  async dispute(observableDocument: ObservableDocumentModel, note: string) {
    const url =
      // @ts-expect-error stop using adapters
      this.buildURL(MODEL_TYPE, observableDocument.id) + '/transition/subsistence-state/dispute';
    const payload = { note };
    await this.ajax(url, 'PATCH', { data: payload });
    await observableDocument.reload();
  }

  async discardObservableDocument(id: string) {
    // @ts-expect-error: As we replace with request manager these will be resolved
    const url = this.buildURL('observable-documents') + `/${id}`;

    return this.ajax(url, 'DELETE');
  }
}

export default ObservableDocumentAdapter;
